import { createAction } from '../utils';
import * as ReleaseNotesActions from '../types/release-notes.types';
export const cacheReleaseNotes = (items) => createAction(ReleaseNotesActions.CACHE_RELEASE_NOTES, { items });
export default cacheReleaseNotes;
